(function () {
  "use strict";

  HeaderCtrl.$inject = ['$scope', '$rootScope', 'trackingService', 'authView', '$window', '$route', '$routeParams', '$location', '$modal', 'gridFormatters', 'mtypes', 'Auth', 'navigationHelper', 'notificationService', 'accountFeatures'];
  angular
    .module('trainerWebApp.controllers')
    .controller('HeaderCtrl', HeaderCtrl);

  function HeaderCtrl($scope, $rootScope, trackingService, authView, $window, $route, $routeParams, $location, $modal,
                      gridFormatters, mtypes, Auth, navigationHelper, notificationService, accountFeatures) {

    var defaultBreadcrumbs = [];
    var homeBreadcrumbItem = {title: "Home", url: "#" + $window.mfConfig.trainerHomeUrl};

    var queryParams = $location.search(); 
    
    $scope.dropDownEnabled = true;
    $rootScope.$watch('enableNormalNav', function() {
      $scope.dropDownEnabled = $rootScope.enableNormalNav;
    });

    $scope.montara = {
      course: queryParams.course,
      series: queryParams.series,
      liveTraining: queryParams.liveTraining
    };

    if ($routeParams.courseId) {
      $scope.courseId = $routeParams.courseId;
      var url = Object.keys(queryParams).filter(function(param) {
        return param !== 'course';
      });
      $scope.courseUrl = url.length ? url[0] : 'users';
    }

    if ($routeParams.seriesId) {
      $scope.seriesId = $routeParams.seriesId;
      var url = Object.keys(queryParams).filter(function(param) {
        return param !== 'series';
      });
      $scope.seriesUrl = url.length ? url[0] : 'users';
    }

    if ($routeParams.liveTraining) {
      $scope.liveTrainingId = $routeParams.courseId;
      var url = Object.keys(queryParams).filter(function(param) {
        return param !== 'liveTraining';
      });
      $scope.liveTrainingUrl = url.length ? url[0] : 'users';
    }

    var hasManageUsersMontaraFeature = !!~accountFeatures.features.indexOf(mtypes.featureEntry.manageUsersMontara);
    $scope.manageUsersUrl = hasManageUsersMontaraFeature ? '/TrainerM/#/ManageUsers' : '#/TMS/ManageUsers';
    $scope.manageAccountLink = "/TrainerM/#/settings";

    function buildDefaultBreadcrumbs() {
      if ($routeParams.seriesId) {
        defaultBreadcrumbs = [
          homeBreadcrumbItem,
          {title: "Series Dashboard", url: "#/TMS/Series/" + $routeParams.seriesId}
        ];
      }
      else if ($routeParams.courseId) {
        defaultBreadcrumbs = [
          homeBreadcrumbItem,
          {title: "Course Dashboard", url: "#/TMS/Distribute_Course/" + $routeParams.courseId, id: 'courseDashboard'}
        ];
      }
      else if ($routeParams.catalogId) {
        defaultBreadcrumbs = [
          homeBreadcrumbItem,
          {title: "Catalog Page", url: "#/TMS/Catalog/" + $routeParams.catalogId}
        ];
      }
      else if ($location.path().indexOf('ManageUsers') != -1 || $location.path().indexOf('ManageGroups') != -1) {
        defaultBreadcrumbs = [
          homeBreadcrumbItem,
          {title: "Manage Users", url: $scope.manageUsersUrl}
        ];
      }
      else if ($location.path().indexOf('Account') != -1) {
        defaultBreadcrumbs = [
          homeBreadcrumbItem,
          {title: "Manage Users", url: $scope.manageUsersUrl}
        ];
      }
      else if ($location.path().indexOf('customFields') != -1) {
        defaultBreadcrumbs = [
          homeBreadcrumbItem,
          {title: "Manage Users", url: $scope.manageUsersUrl}
        ];
      }
      else if ($location.path().indexOf('Shopify') != -1) {
        defaultBreadcrumbs = [
          homeBreadcrumbItem,
          {title: "Settings", url: $scope.manageAccountLink},
          {title: "Shopify", url: "#/TMS/Shopify"}
        ];
      }
      else if ($location.path().indexOf('Branding') != -1) {
        defaultBreadcrumbs = [
          homeBreadcrumbItem,
          {title: "Settings", url: $scope.manageAccountLink},
          {title: "Logo and Colors", url: "#/TMS/Branding"}
        ];
      }
      else if ($location.path().indexOf('Features') != -1) {
        defaultBreadcrumbs = [
          homeBreadcrumbItem,
          {title: "Feature Preview", url: "#/Features"}
        ];
      }
      else if ($location.path().indexOf('Home') != -1) {
        defaultBreadcrumbs = [
          homeBreadcrumbItem
        ];
      }
      else {
        defaultBreadcrumbs = [];
      }
    }

    if ($route.current) {
      buildBreadcrumb(getCurrentPageName());
    }

    $rootScope.$on("$routeChangeSuccess", function () {
      buildBreadcrumb(getCurrentPageName());
      calcAccountStatusInfo();
    });

    function buildBreadcrumb(currentPage) {
      $scope.upsellBannerVisible = upsellBannerVisible();
      $scope.hideupsellBanner = false;
      $scope.breadcrumbs = [];
      buildDefaultBreadcrumbs();
      $scope.breadcrumbs = defaultBreadcrumbs;
      switch (currentPage) {
        case 'manageUsers' :
        {
          $scope.breadcrumbs = [homeBreadcrumbItem, {title: "Manage Users"}];
          break;
        }
        case 'trainees' :
        {
          $scope.breadcrumbs = defaultBreadcrumbs.concat([
            {title: "Trainees"}
          ]);
          break;
        }
        case 'addExistingTrainees' :
        {
          if ($routeParams.seriesId) {
            $scope.breadcrumbs = defaultBreadcrumbs.concat({
              title: "Trainees",
              url: "#/TMS/Series/" + $routeParams.seriesId + "/trainees"
            });
          }
          else if ($routeParams.courseId) {
            $scope.breadcrumbs = defaultBreadcrumbs.concat({
              title: "Trainees",
              url: "#/TMS/Distribute_Course/" + $routeParams.courseId + "/trainees"
            });
          }
          $scope.breadcrumbs.push({title: "Invite Existing Trainees"});
          $scope.hideupsellBanner = true;
          break;
        }
        case 'addYammerUsers' :
        {
          if ($routeParams.seriesId) {
            $scope.breadcrumbs = defaultBreadcrumbs.concat({
              title: "Trainees",
              url: "#/TMS/Series/" + $routeParams.seriesId + "/trainees"
            });
          }
          else if ($routeParams.courseId) {
            $scope.breadcrumbs = defaultBreadcrumbs.concat({
              title: "Trainees",
              url: "#/TMS/Distribute_Course/" + $routeParams.courseId + "/trainees"
            });
          }
          $scope.breadcrumbs.push({title: "Add Yammer Users"});
          $scope.hideupsellBanner = true;
          break;
        }
        case 'addNewUser' :
        {
          if ($routeParams.seriesId) {
            $scope.breadcrumbs = defaultBreadcrumbs.concat({
              title: "Trainees",
              url: "#/TMS/Series/" + $routeParams.seriesId + "/trainees"
            });
          }
          else if ($routeParams.courseId) {
            $scope.breadcrumbs = defaultBreadcrumbs.concat({
              title: "Trainees",
              url: "#/TMS/Distribute_Course/" + $routeParams.courseId + "/trainees"
            });
          }
          $scope.breadcrumbs.push({title: "Add New Trainees"});
          $scope.hideupsellBanner = true;
          break;
        }
        case 'importXls' :
        {
          if ($routeParams.seriesId) {
            $scope.breadcrumbs = defaultBreadcrumbs.concat({
              title: "Trainees",
              url: "#/TMS/Series/" + $routeParams.seriesId + "/trainees"
            });
          }
          else if ($routeParams.courseId) {
            $scope.breadcrumbs = defaultBreadcrumbs.concat({
              title: "Trainees",
              url: "#/TMS/Distribute_Course/" + $routeParams.courseId + "/trainees"
            });
          }
          $scope.breadcrumbs.push({title: "Upload Trainees from Excel"});
          $scope.hideupsellBanner = true;
          break;
        }
        case 'courseEmails' :
        {
          $scope.breadcrumbs.push({title: "Customize Emails"});
          $scope.hideupsellBanner = true;
          break;
        }
        case 'manageCustomFields' :
        {
          $scope.breadcrumbs.push({title: "Manage Custom Fields"});
          break;
        }
        case 'manageGroups' :
        {
          $scope.breadcrumbs.push({title: "Manage Groups"});
          break;
        }
        case 'createNewGroup':
        {
          $scope.breadcrumbs.push({title: "Manage Groups", url: "#/TMS/ManageGroups"});
          $scope.breadcrumbs.push({title: "Create New Group"});
          $scope.hideupsellBanner = true;
          break;
        }
        case 'addContentToCatalog' :
        {
          $scope.breadcrumbs.push({title: "Add Content"});
          break;
        }
        case 'home':
        {
          break;
        }
        case 'customCertificate':
        {
          if ($routeParams.seriesId) {
            $scope.breadcrumbs.push({title: "Customize", url: "#/TMS/Series/" + $routeParams.seriesId + '/customize'});
          } else {

            var courseDashboard = _.find($scope.breadcrumbs, function (i) {
              return i.id == 'courseDashboard';
            });
            courseDashboard.url = '#/TMS/Course_Dashboard/' + $routeParams.courseId;

            $scope.breadcrumbs.push({title: "Customize", url: "#/TMS/Customize_Settings/" + $routeParams.courseId});
          }
          $scope.breadcrumbs.push({title: 'Custom Certificate'});
          $scope.hideupsellBanner = true;
          break;
        }
        case 'addShopifyCourses':
        {
          $scope.breadcrumbs.push({title: "Add Content"});
          $scope.hideupsellBanner = true;
          break;
        }
        default :
        {
          $scope.breadcrumbs = defaultBreadcrumbs;
        }
      }
    }

    function getCurrentPageName() {
      return $routeParams.tabName || ($route.current || {}).pageName;
    }

    $scope.enableNormalNav = true;
    $rootScope.$watch('enableNormalNav', function() {
      $scope.enableNormalNav = $rootScope.enableNormalNav;
    });

    $scope.tierDescription = function () {
      return authView.getTierDescription();
    };

    $scope.featureBannerVisible = function () {
      var page = notificationService.getNotification();
      var location = page && page.length > 0 ? $location.path().indexOf(page[0].pageToShow) != -1 ? true : false : false;
      return location;
    };

    function getFeatureBanner() {
      var notifications = notificationService.getNotification();
      return notifications ? notifications : [];
    }

    $scope.featureBannerText = function () {
      return _.sortBy(getFeatureBanner(), function (obj) {
        return obj.displayOrder;
      })
    }

    $scope.removeNotification = function (notification) {
      notificationService.removeNotification(notification);
    }

    $scope.notificationBtn = function (notification) {
      if (!notification || !notification.btnUrl) return;
      $location.path(notification.btnUrl);
    }

    var accountStatusMessages = {};
    accountStatusMessages[mtypes.accountStatus.cancellationPending] = {
      message: "Your account has been cancelled and will end on {DATE}.",
      cssClass: 'account-status-warning-message'
    };

    $scope.accountStatusInfo = null;
    calcAccountStatusInfo();

    function calcAccountStatusInfo() {
      if (getCurrentPageName() != 'home') {
        $scope.accountStatusInfo = null;
        upsellBannerVisible();
        return;
      }

      var info = accountStatusMessages[$rootScope.mfConfig.accountStatus];
      if (!info) return;
      info = _.clone(info);

      if (~info.message.indexOf('{DATE}')) {
        var dateString = '';
        if ($rootScope.mfConfig.accountStatus == mtypes.accountStatus.cancellationPending) {
          dateString = gridFormatters.dateFormatterBasic($rootScope.mfConfig.accountCancellationDate);
        }
        info.message = info.message.replace(/\{DATE\}/, dateString);
      }
      $scope.accountStatusInfo = info;
      upsellBannerVisible();
    }

    upsellBannerVisible();

    //We only want show the upsell to admins. Cancelled accounts and trials trump
    function upsellBannerVisible() {
      $scope.upsellBannerIsVisible = (authView.isAdministrator() && (authView.isTrial() || authView.isInFeatureTrial()) && !$scope.accountStatusInfo) && !$scope.hideupsellBanner;
    }

    $scope.getUpsellBannerText = function () {
      var daysLeft;
      if (authView.isTrial()) {
        daysLeft = authView.getTrialDaysLeft();
        if (daysLeft > 0)
          return daysLeft + ' ' + dayFormatter(daysLeft) + ' left in your free trial.';
      }
      if (authView.isInFeatureTrial()) {
        daysLeft = authView.getAdvancedTrialDaysLeft();
        if (daysLeft > 0)
          return daysLeft + ' ' + dayFormatter(daysLeft) + ' left in your Advanced Plan free trial.';
      }
      return '';
    };

    $scope.getUpsellBannerLinkText = function () {
      if (authView.isTrial()) {
        return 'Subscribe now.';
      }
      if (authView.isInFeatureTrial()) {
        return 'Upgrade now.';
      }
      return '';
    };

    $scope.onSubscribeNowClick = function () {
      trackEvent(trackingService.pages.trainerWeb.actions.pickPlanLightboxOpened);
      return $location.path('/TMS/Manage_Account/Subscribe');
    };

    $scope.onManageUsersClick = function () {
      trackEvent(trackingService.pages.trainerWeb.actions.manageUsersDropDownLinkClicked);
      var hasManageUsersMontaraFeature = !!~accountFeatures.features.indexOf(mtypes.featureEntry.manageUsersMontara);
      if (hasManageUsersMontaraFeature)
        $window.location.href = '/TrainerM/#/users';
      else
        $location.path('/TMS/ManageUsers');
    };

    function dayFormatter(numberOfDays) {
      return numberOfDays > 1 ? 'days' : 'day';
    }

    $scope.baseLocation = 'https://' + $window.location.host;

    $scope.viewState = {
      manageAccountLink: authView.getManageAccountLink()
    };

    $scope.$watch(Auth.userRole, function (newValue, oldValue) {
      if (newValue != oldValue)
        $scope.viewState.manageAccountLink = authView.getManageAccountLink();
    });

    $scope.editProfile = function () {
      $modal.open({
        templateUrl: 'pages/modals/editProfile.html'
      });
    };

    $scope.breadcrumbClicked = function (breadcrumb) {
      navigationHelper.setBreadcrumbClicked();
    };

    function trackEvent(event) {
      trackingService.trackEvent(getPageForGoogleAnalytics(), event);
    }

    function getPageForGoogleAnalytics() {
      var retVal = '';

      switch (getCurrentPageName()) {
        case 'manageUsers' :
        {
          retVal = trackingService.pages.usersManage.name;
          break;
        }
        case 'trainees' :
        case 'addExistingTrainees' :
        case 'addYammerUsers' :
        case 'addNewUser' :
        case 'importXls' :
        case 'manageCustomFields' :
        case 'manageGroups' :
        {
          retVal = trackingService.pages.usersManage.name;
          break;
        }
        case 'series':
        {
          retVal = trackingService.pages.seriesDashboard.name;
          break;
        }
        case 'home':
        {
          retVal = trackingService.pages.trainerHome.name;
          break;
        }
        default :
        {
          retVal = trackingService.pages.trainerWeb.name;
        }
      }

      return retVal;
    }
  }
})();
